document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth > 767) return;

  var galleries = document.querySelectorAll('.sc-mobile-product-gallery');

  galleries.forEach(function (gallery) {
    var viewport = gallery.querySelector('[data-sc-mobile-gallery-viewport]');
    var items = gallery.querySelectorAll('[data-sc-mobile-gallery-item]');
    var dots = gallery.querySelectorAll('[data-sc-mobile-gallery-dot]');

    if (!viewport || !items.length || !dots.length) return;

    function setActiveDot(index) {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    function getNearestIndex() {
      var scrollLeft = Math.abs(viewport.scrollLeft);
      var itemWidth = items[0].offsetWidth + 10;
      var index = Math.round(scrollLeft / itemWidth);
      index = Math.max(0, Math.min(index, items.length - 1));
      return index;
    }

    var scrollTimer;
    viewport.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        setActiveDot(getNearestIndex());
      }, 60);
    }, { passive: true });

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        var target = items[index];
        if (!target) return;

        viewport.scrollTo({
          left: target.offsetLeft - viewport.offsetLeft,
          behavior: 'smooth'
        });

        setActiveDot(index);
      });
    });

    setActiveDot(0);
  });
});

document.addEventListener('DOMContentLoaded', function () {

  function escapeHtml(str) {
    return String(str || '').replace(/[&<>"']/g, function (m) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[m];
    });
  }

  function truncateText(str, max) {
    const s = String(str || '').trim();
    if (!s) return '';
    return s.length > max ? s.slice(0, max).trim() + '…' : s;
  }

  document.querySelectorAll('.sc-pdp-review-summary').forEach(async function (mount) {
    const productId = mount.getAttribute('data-product-id');
    const limit = parseInt(mount.getAttribute('data-review-limit') || '8', 10);

    if (!productId) {
      mount.style.display = 'none';
      return;
    }

    try {
      const url = `https://growave-function.netlify.app/.netlify/functions/growave-reviews?productId=${productId}&limit=${limit}`;
      const res = await fetch(url);
      const data = await res.json();

      if (!data.ok || !Array.isArray(data.items) || !data.items.length) {
        mount.style.display = 'none';
        return;
      }

      const items = data.items.map(function (item) {
        const hasImage = Array.isArray(item.images) && item.images.length > 0;
        return {
          text: (item.text || item.title || item.body || '').trim(),
          image: hasImage ? item.images[0] : '',
          rating: item.rating || item.rate || 5,
          hasImage: hasImage
        };
      }).filter(function (item) {
        return item.text || item.image;
      });

      if (!items.length) {
        mount.style.display = 'none';
        return;
      }

      const reviewCards = items.map(function (item) {
        if (item.hasImage) {
          return `
            <div class="sc-pdp-review-strip__item">
              <div class="sc-pdp-review-summary__review-card">
                <div class="sc-pdp-review-summary__review-image">
                  <img src="${escapeHtml(item.image)}" alt="" loading="lazy">
                </div>
                <div class="sc-pdp-review-summary__review-body">
                  <div class="sc-pdp-review-summary__review-stars">${'★'.repeat(Math.max(1, Math.min(5, item.rating)))}</div>
                  <div class="sc-pdp-review-summary__review-text">${escapeHtml(truncateText(item.text, 95))}</div>
                </div>
              </div>
            </div>
          `;
        }

        return `
          <div class="sc-pdp-review-strip__item sc-pdp-review-strip__item--textonly">
            <div class="sc-pdp-review-summary__review-card sc-pdp-review-summary__review-card--textonly">
              <div class="sc-pdp-review-summary__review-body">
                <div class="sc-pdp-review-summary__review-stars">${'★'.repeat(Math.max(1, Math.min(5, item.rating)))}</div>
                <div class="sc-pdp-review-summary__review-text">${escapeHtml(truncateText(item.text, 120))}</div>
              </div>
            </div>
          </div>
        `;
      }).join('');

      mount.innerHTML = `
        <div class="sc-pdp-review-strip">
          <div class="sc-pdp-review-strip__track">
            ${reviewCards}
          </div>
        </div>
      `;
      document.dispatchEvent(new CustomEvent('sc:pdp-reviews-rendered'));
    } catch (e) {
      console.error('Growave summary failed', e);
      mount.style.display = 'none';
    }
  });
});

window.ScPdpFeatureChips = window.ScPdpFeatureChips || {
  safeParse: function (json) {
    try {
      return JSON.parse(json || '[]');
    } catch (e) {
      return [];
    }
  },

  updateOriginInScope: function (scopeEl, variantId) {
    if (!scopeEl) return;

    var wrap = scopeEl.querySelector('[data-sc-pdp-feature-chips]');
    if (!wrap) return;

    var chip = wrap.querySelector('[data-chip-origin]');
    if (!chip) return;

    var map = window.ScPdpFeatureChips.safeParse(wrap.getAttribute('data-variant-origin-map'));
    var textEl = chip.querySelector('.sc-pdp-feature-chip__text');

    var found = map.find(function (item) {
      return String(item.id) === String(variantId);
    });

    var origin = found && found.origin ? String(found.origin).trim() : '';

    if (!origin) {
      chip.classList.add('is-hidden');
      if (textEl) textEl.textContent = '';
      return;
    }

    if (textEl) textEl.textContent = origin;
    chip.classList.remove('is-hidden');
  }
};

document.addEventListener('DOMContentLoaded', function () {
  function openSheet(sheet, trigger) {
  if (!sheet) return;

  // Save original position once
  if (!sheet.__scOriginalParent) {
    sheet.__scOriginalParent = sheet.parentNode;
    sheet.__scOriginalNextSibling = sheet.nextSibling;
  }

  // Move drawer to body so it overlays the full page/header/search correctly
  if (sheet.parentNode !== document.body) {
    document.body.appendChild(sheet);
  }

  sheet.hidden = false;
  sheet.classList.remove('is-closing');

  document.body.classList.add('sc-pdp-drawer-open');

  requestAnimationFrame(function () {
    sheet.classList.add('is-open');
  });

  document.body.style.overflow = 'hidden';

  if (trigger) {
    trigger.setAttribute('aria-expanded', 'true');
  }
}

function closeSheet(sheet) {
  if (!sheet) return;

  sheet.classList.remove('is-open');
  sheet.classList.add('is-closing');

  window.setTimeout(function () {
    sheet.hidden = true;
    sheet.classList.remove('is-closing');

    document.body.style.overflow = '';
    document.body.classList.remove('sc-pdp-drawer-open');

    document.querySelectorAll('[data-sc-pdp-desc-open][aria-expanded="true"]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
    });

    // Restore drawer back to original PDP location after closing
    if (sheet.__scOriginalParent) {
      sheet.__scOriginalParent.insertBefore(sheet, sheet.__scOriginalNextSibling);
    }
  }, 520);
}

  function parseStructuredDescription(html) {
  var parser = new DOMParser();
  var doc = parser.parseFromString('<div class="sc-desc-root">' + (html || '') + '</div>', 'text/html');
  var root = doc.querySelector('.sc-desc-root');

  var result = {
    description: '',
    applications: '',
    storage: '',
    recipe: '',
    isFallback: false
  };

  if (!root) return result;

  var tab1 = root.querySelector('#tab1');
  var tab2 = root.querySelector('#tab2');
  var tab3 = root.querySelector('#tab3');
  var tab4 = root.querySelector('#tab4');

  var hasStructuredTabs = !!(tab1 || tab2 || tab3 || tab4);

  /*
    Disclaimer is appended to product.descriptionHtml outside #tab1/#tab2/#tab3/#tab4.
    Without this, structured product descriptions ignore the disclaimer.
  */
  var disclaimerEl = root.querySelector('[data-sc-brand-origin-disclaimer="true"]');
  var disclaimerHtml = disclaimerEl ? disclaimerEl.outerHTML.trim() : '';

  if (hasStructuredTabs) {
    if (tab1) result.description = tab1.innerHTML.trim();
    if (tab2) result.applications = tab2.innerHTML.trim();
    if (tab3) result.storage = tab3.innerHTML.trim();
    if (tab4) result.recipe = tab4.innerHTML.trim();

    /*
      Add disclaimer inside Description tab only.
      Avoid duplicate if disclaimer is already inside tab1.
    */
    if (
      disclaimerHtml &&
      result.description.indexOf('data-sc-brand-origin-disclaimer="true"') === -1
    ) {
      result.description = result.description
        ? result.description + '\n\n' + disclaimerHtml
        : disclaimerHtml;
    }

    return result;
  }

  var plainDescription = root.innerHTML.trim();

  if (plainDescription) {
    result.description = plainDescription;
    result.isFallback = true;
  }

  return result;
}

  document.querySelectorAll('[data-sc-pdp-desc-tabs]').forEach(function (tabsWrap) {
    var sourceEl = tabsWrap.querySelector('[data-sc-pdp-desc-source]');
    if (!sourceEl) return;

    var rawHtml = '';
    try {
      rawHtml = JSON.parse(sourceEl.textContent || '""');
    } catch (e) {
      rawHtml = '';
    }

    var sections = parseStructuredDescription(rawHtml);

    tabsWrap.classList.toggle('is-plain-description', !!sections.isFallback);

if (sections.isFallback) {
  ['applications', 'storage', 'recipe'].forEach(function (key) {
    var tab = tabsWrap.querySelector('[data-tab-target="' + key + '"]');
    var panel = tabsWrap.querySelector('[data-tab-panel="' + key + '"]');

    if (tab) tab.style.display = 'none';

    if (panel) {
      panel.innerHTML = '';
      panel.setAttribute('data-empty', 'true');
      panel.classList.remove('is-active');
    }
  });
}

    ['description', 'applications', 'storage', 'recipe'].forEach(function (key) {
      var panel = tabsWrap.querySelector('[data-tab-panel="' + key + '"]');
      var tab = tabsWrap.querySelector('[data-tab-target="' + key + '"]');
      if (!panel) return;

      if (sections[key] && sections[key].trim()) {
        panel.innerHTML = sections[key];
        panel.removeAttribute('data-empty');
      } else {
        panel.innerHTML = '';
        panel.setAttribute('data-empty', 'true');
        if (tab) tab.style.display = 'none';
      }
    });

    var tabs = Array.from(tabsWrap.querySelectorAll('.sc-pdp-desc-tabs__tab')).filter(function (tab) {
      return tab.style.display !== 'none';
    });

    var panels = Array.from(tabsWrap.querySelectorAll('.sc-pdp-desc-tabs__panel')).filter(function (panel) {
      return panel.getAttribute('data-empty') !== 'true';
    });

    tabs.forEach(function (tab) {
      tab.classList.remove('is-active');
    });

    panels.forEach(function (panel) {
      panel.classList.remove('is-active');
    });

    if (tabs.length) {
      tabs[0].classList.add('is-active');
      var firstTarget = tabs[0].getAttribute('data-tab-target');
      var firstPanel = tabsWrap.querySelector('[data-tab-panel="' + firstTarget + '"]');
      if (firstPanel) firstPanel.classList.add('is-active');
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-tab-target');

        tabs.forEach(function (t) {
          t.classList.remove('is-active');
        });

        tabsWrap.querySelectorAll('.sc-pdp-desc-tabs__panel').forEach(function (panel) {
          panel.classList.remove('is-active');
        });

        tab.classList.add('is-active');

        var activePanel = tabsWrap.querySelector('[data-tab-panel="' + target + '"]');
        if (activePanel) activePanel.classList.add('is-active');
      });
    });
  });

  document.querySelectorAll('[data-sc-pdp-desc-open]').forEach(function (btn) {
  btn.addEventListener('click', function () {
    var targetSelector = btn.getAttribute('data-sc-pdp-sheet-target');
    var sheet = null;

    if (targetSelector) {
      sheet = document.querySelector(targetSelector);
    } else {
      var wrap = btn.closest('.sc-pdp-highlights');
      if (wrap) {
        sheet = wrap.querySelector('[data-sc-pdp-desc-sheet]');
      }
    }

    openSheet(sheet, btn);
  });
});

  document.querySelectorAll('[data-sc-pdp-desc-close]').forEach(function (el) {
    el.addEventListener('click', function () {
      var sheet = el.closest('[data-sc-pdp-desc-sheet]');
      closeSheet(sheet);
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-sc-pdp-desc-sheet]').forEach(function (sheet) {
      if (!sheet.hidden) closeSheet(sheet);
    });
  });
});

/* PDP mini ATC removed: handled by unified sc-mini-atc.js. */
document.addEventListener('DOMContentLoaded', function () {
  function getSelectedCityLabel() {
    if (window.CityState && typeof window.CityState.get === 'function' && typeof window.CityState.getLabel === 'function') {
      var city = window.CityState.get();
      return window.CityState.getLabel(city) || '';
    }

    var cityAttr = document.documentElement.getAttribute('data-selected-city') || '';
    return cityAttr ? cityAttr.replace(/_/g, ' ').replace(/\b\w/g, function (m) { return m.toUpperCase(); }) : '';
  }

  function isArabic() {
    return (document.documentElement.lang || '').toLowerCase().indexOf('ar') > -1 ||
           (document.documentElement.dir || '').toLowerCase() === 'rtl';
  }

  function formatText(template, city) {
    return String(template || '').replace('[city]', city || '');
  }

  function updateStockUrgency() {
    var el = document.querySelector('[data-sc-pdp-stock-urgency]');
    if (!el) return;

    var city = getSelectedCityLabel();
    var isAr = isArabic();

    var threshold = Number(el.getAttribute('data-low-stock-threshold') || '15');
    var qty = Number(el.getAttribute('data-current-qty') || '0');

    var textEl = el.querySelector('.sc-pdp-stock-urgency__text');
    if (!textEl) return;

    if (qty > 0 && qty < threshold && city) {
      var template = isAr ? textEl.getAttribute('data-text-ar') : textEl.getAttribute('data-text-en');
      textEl.textContent = formatText(template, city);
      el.classList.remove('is-hidden');
    } else {
      el.classList.add('is-hidden');
    }
  }

  function syncUrgencyBlocks() {
    updateStockUrgency();
  }

  document.addEventListener('city:changed', function () {
    setTimeout(syncUrgencyBlocks, 80);
  });

  document.addEventListener('variant:changed', function () {
    setTimeout(syncUrgencyBlocks, 80);
  });

  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches('form[action*="/cart/add"] [name="id"]')) {
      setTimeout(syncUrgencyBlocks, 80);
    }
  });

  syncUrgencyBlocks();
});
/* =========================================================
   PDP Reviews - Move below Add to Cart on desktop only
   Mobile remains unchanged
   ========================================================= */
document.addEventListener('DOMContentLoaded', function () {
  var reviewSummary = document.querySelector('.sc-pdp-review-summary');
  if (!reviewSummary) return;

  var originalParent = reviewSummary.parentNode;
  var originalNextSibling = reviewSummary.nextSibling;
  var desktopMount = null;

  function findDesktopCtaTarget() {
    return (
      document.querySelector('.sc-pdp-purchase-desktop') ||
      document.querySelector('[data-sc-pdp-purchase-wrap]') ||
      document.querySelector('.t4s-product__info-wrapper form[action*="/cart/add"]') ||
      document.querySelector('.t4s-product__info-wrapper')
    );
  }

  function moveReviews() {
    var isDesktop = window.innerWidth >= 768;

    if (isDesktop) {
      var target = findDesktopCtaTarget();
      if (!target) return;

      if (!desktopMount) {
        desktopMount = document.createElement('div');
        desktopMount.className = 'sc-pdp-review-summary-cta-mount';
      }

      /*
        Place review mount directly after the Add to Cart / mini ATC area.
      */
      if (target.nextSibling !== desktopMount) {
        target.parentNode.insertBefore(desktopMount, target.nextSibling);
      }

      if (reviewSummary.parentNode !== desktopMount) {
        desktopMount.appendChild(reviewSummary);
      }

      reviewSummary.classList.add('is-desktop-positioned');
    } else {
      /*
        Restore original mobile position.
      */
      if (originalParent && reviewSummary.parentNode !== originalParent) {
        originalParent.insertBefore(reviewSummary, originalNextSibling);
      }

      reviewSummary.classList.remove('is-desktop-positioned');
    }
  }

  moveReviews();

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(moveReviews, 150);
  });
});
/* =========================================================
   PDP Reviews - FBT style desktop controls
   RTL-safe + duplicate-safe
   ========================================================= */
document.addEventListener('DOMContentLoaded', function () {
  function initPdpReviewControls() {
    document.querySelectorAll('.sc-pdp-review-summary').forEach(function (summary) {
      var track = summary.querySelector('.sc-pdp-review-strip__track');
      var strip = summary.querySelector('.sc-pdp-review-strip');

      if (!track || !strip) return;

      /* Mobile: remove desktop controls completely */
      if (window.innerWidth < 768) {
        summary.querySelectorAll('.sc-pdp-review-scrollbar').forEach(function (el) {
          el.remove();
        });
        summary.classList.add('sc-pdp-review-summary--no-scroll-controls');
        delete summary.dataset.scPdpReviewControlsBound;
        return;
      }

      /* Keep scroll mechanics LTR in Arabic */
      track.style.setProperty('direction', 'ltr', 'important');

      function forceLTRTrack() {
        track.style.setProperty('direction', 'ltr', 'important');
      }

      function getMaxScroll() {
        forceLTRTrack();
        return Math.max(0, Math.ceil(track.scrollWidth - track.clientWidth));
      }

      function getScrollPosition() {
        forceLTRTrack();
        return Math.max(0, track.scrollLeft || 0);
      }

      function setScrollLeft(value, smooth) {
        forceLTRTrack();

        var maxScroll = getMaxScroll();
        var safeValue = Math.max(0, Math.min(value, maxScroll));

        if (typeof track.scrollTo === 'function') {
          track.scrollTo({
            left: safeValue,
            behavior: smooth ? 'smooth' : 'auto'
          });
        } else {
          track.scrollLeft = safeValue;
        }

        setTimeout(function () {
          if (typeof summary._scPdpReviewUpdateControls === 'function') {
            summary._scPdpReviewUpdateControls();
          }
        }, 80);

        setTimeout(function () {
          if (typeof summary._scPdpReviewUpdateControls === 'function') {
            summary._scPdpReviewUpdateControls();
          }
        }, 260);
      }

      var items = track.querySelectorAll('.sc-pdp-review-strip__item');
      var maxScroll = getMaxScroll();

      /* No meaningful overflow: remove controls */
      if (items.length <= 3 || maxScroll <= 80) {
        summary.querySelectorAll('.sc-pdp-review-scrollbar').forEach(function (el) {
          el.remove();
        });
        summary.classList.add('sc-pdp-review-summary--no-scroll-controls');
        delete summary.dataset.scPdpReviewControlsBound;
        return;
      }

      summary.classList.remove('sc-pdp-review-summary--no-scroll-controls');

      /*
        Hard duplicate cleanup:
        Keep only one scrollbar if older runs already created multiple.
      */
      var existingControls = Array.prototype.slice.call(
        summary.querySelectorAll('.sc-pdp-review-scrollbar')
      );

      if (existingControls.length > 1) {
        existingControls.slice(1).forEach(function (el) {
          el.remove();
        });
      }

      var controls = summary.querySelector('.sc-pdp-review-scrollbar');

      /*
        If already initialized, do not bind events again.
        Just update the existing scrollbar.
      */
      if (controls && summary.dataset.scPdpReviewControlsBound === 'true') {
        if (typeof summary._scPdpReviewUpdateControls === 'function') {
          summary._scPdpReviewUpdateControls();
        }
        return;
      }

      if (!controls) {
        controls = document.createElement('div');
        controls.className = 'sc-pdp-review-scrollbar';

        controls.innerHTML = `
          <button type="button" class="sc-pdp-review-scrollbar__arrow sc-pdp-review-scrollbar__arrow--prev" aria-label="Previous reviews">‹</button>
          <div class="sc-pdp-review-scrollbar__track">
            <div class="sc-pdp-review-scrollbar__thumb"></div>
          </div>
          <button type="button" class="sc-pdp-review-scrollbar__arrow sc-pdp-review-scrollbar__arrow--next" aria-label="Next reviews">›</button>
        `;

        strip.insertAdjacentElement('afterend', controls);
      }

      summary.dataset.scPdpReviewControlsBound = 'true';

      var prevBtn = controls.querySelector('.sc-pdp-review-scrollbar__arrow--prev');
      var nextBtn = controls.querySelector('.sc-pdp-review-scrollbar__arrow--next');
      var bar = controls.querySelector('.sc-pdp-review-scrollbar__track');
      var thumb = controls.querySelector('.sc-pdp-review-scrollbar__thumb');

      if (!prevBtn || !nextBtn || !bar || !thumb) return;

      var isDraggingThumb = false;
      var dragStartX = 0;
      var dragStartScrollLeft = 0;

      function getClientX(event) {
        if (event.touches && event.touches.length) return event.touches[0].clientX;
        if (event.changedTouches && event.changedTouches.length) return event.changedTouches[0].clientX;
        return event.clientX;
      }

      function updateControls() {
        forceLTRTrack();

        var currentMax = getMaxScroll();

        if (currentMax <= 80) {
          controls.remove();
          summary.classList.add('sc-pdp-review-summary--no-scroll-controls');
          delete summary.dataset.scPdpReviewControlsBound;
          return;
        }

        var scrollPosition = getScrollPosition();
        var progress = currentMax > 0 ? scrollPosition / currentMax : 0;
        progress = Math.max(0, Math.min(1, progress));

        var barWidth = bar.clientWidth;
        var visibleRatio = track.clientWidth / track.scrollWidth;

        var thumbWidthPx = Math.max(90, barWidth * visibleRatio);
        thumbWidthPx = Math.min(barWidth, thumbWidthPx);

        var maxLeftPx = Math.max(0, barWidth - thumbWidthPx);
        var leftPx = progress * maxLeftPx;

        thumb.style.width = thumbWidthPx + 'px';
        thumb.style.transform = 'translateX(' + leftPx + 'px)';

        var atStart = scrollPosition <= 2;
        var atEnd = scrollPosition >= currentMax - 2;

        prevBtn.disabled = atStart;
        nextBtn.disabled = atEnd;

        controls.classList.toggle('is-at-start', atStart);
        controls.classList.toggle('is-at-end', atEnd);
      }

      summary._scPdpReviewUpdateControls = updateControls;

      function getScrollStep() {
        var firstItem = track.querySelector('.sc-pdp-review-strip__item');
        if (!firstItem) return Math.round(track.clientWidth * 0.8);

        var gap = 12;
        var secondItem = track.querySelectorAll('.sc-pdp-review-strip__item')[1];

        if (secondItem) {
          var firstRect = firstItem.getBoundingClientRect();
          var secondRect = secondItem.getBoundingClientRect();
          var measuredGap = Math.round(secondRect.left - firstRect.right);

          if (!Number.isNaN(measuredGap) && measuredGap >= 0 && measuredGap <= 40) {
            gap = measuredGap;
          }
        }

        return Math.round(firstItem.offsetWidth + gap);
      }

      function scrollOne(direction) {
        forceLTRTrack();

        var amount = getScrollStep();
        var current = getScrollPosition();

        setScrollLeft(current + direction * amount, true);
      }

      function onThumbDragStart(event) {
        isDraggingThumb = true;
        dragStartX = getClientX(event);
        dragStartScrollLeft = getScrollPosition();

        thumb.classList.add('is-dragging');

        if (event.cancelable) {
          event.preventDefault();
        }
      }

      function onThumbDragMove(event) {
        if (!isDraggingThumb) return;

        var currentMax = getMaxScroll();
        var barWidth = bar.clientWidth;
        var thumbWidth = thumb.offsetWidth;
        var maxThumbMove = barWidth - thumbWidth;

        if (currentMax <= 0 || maxThumbMove <= 0) return;

        var currentX = getClientX(event);
        var deltaX = currentX - dragStartX;
        var scrollDelta = (deltaX / maxThumbMove) * currentMax;

        setScrollLeft(dragStartScrollLeft + scrollDelta, false);

        if (event.cancelable) {
          event.preventDefault();
        }
      }

      function onThumbDragEnd() {
        if (!isDraggingThumb) return;

        isDraggingThumb = false;
        thumb.classList.remove('is-dragging');
      }

      function onTrackClick(event) {
        if (event.target === thumb) return;

        var rect = bar.getBoundingClientRect();
        var clickX = event.clientX - rect.left;
        var barWidth = bar.clientWidth;
        var thumbWidth = thumb.offsetWidth;
        var maxThumbMove = barWidth - thumbWidth;
        var currentMax = getMaxScroll();

        if (currentMax <= 0 || maxThumbMove <= 0) return;

        var targetThumbLeft = clickX - thumbWidth / 2;
        targetThumbLeft = Math.max(0, Math.min(targetThumbLeft, maxThumbMove));

        setScrollLeft((targetThumbLeft / maxThumbMove) * currentMax, true);
      }

      prevBtn.addEventListener('click', function () {
        scrollOne(-1);
      });

      nextBtn.addEventListener('click', function () {
        scrollOne(1);
      });

      thumb.addEventListener('mousedown', onThumbDragStart);
      thumb.addEventListener('touchstart', onThumbDragStart, { passive: false });

      window.addEventListener('mousemove', onThumbDragMove);
      window.addEventListener('touchmove', onThumbDragMove, { passive: false });

      window.addEventListener('mouseup', onThumbDragEnd);
      window.addEventListener('touchend', onThumbDragEnd);
      window.addEventListener('touchcancel', onThumbDragEnd);

      bar.addEventListener('click', onTrackClick);

      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(updateControls);
      }, { passive: true });

      updateControls();
      setTimeout(updateControls, 300);
    });
  }

  document.addEventListener('sc:pdp-reviews-rendered', function () {
    setTimeout(initPdpReviewControls, 200);
  });

  window.addEventListener('resize', function () {
    setTimeout(initPdpReviewControls, 200);
  });

  setTimeout(initPdpReviewControls, 900);
  setTimeout(initPdpReviewControls, 1800);
});